import React, {FC, useState} from 'react';
import {useFormik} from 'formik';
import {ReactComponent as CloseIcon} from '../../assets/form/close-form.svg';
import {useAppDispatch} from '../../common/hook';
import {ReactComponent as CalendarIcon} from '../../assets/main/profile-box/calendar.svg';
import {useInputWithFocus} from "../../common/hook/useInputWithFocus";
import {setAddCutAC} from "../../app/popups-reducer";
import {postStudentInfoCut} from "features/model/service/add-cut/postStudentInfoCut";
import {useParams} from "react-router-dom";
import {CutCalendar} from "../calendar/CutCalendar";
import {fetchStudentCuts} from "features/model/service/student-info/student-info-cuts/fetchStudentInfoCuts";
import { message } from 'antd';
interface MyFormValues {
    date: string;
    reading: string;
    speaking: string;
    listening: string;
    writing: string;
    grammar: string;
}

export const FormAddCut: FC = () => {
    const dispatch = useAppDispatch();
    const [isOpen, setIsOpen] = useState(false);
    const { groupId,studentId } = useParams();
    const [selectedDate, setSelectedDate] = useState<string>('');
    const {isFilled, handleFocus, handleBlur} = useInputWithFocus([
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
    ]);

    const handleDateSelected = (date: string) => {
        setSelectedDate(date);
    };


    const handleClose = () => {
        setIsOpen(false);
    };

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    const success = () => {
        message.success('Срез успешно добавлен');
    };


    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} = e.target;
        const parsedValue = parseInt(value.replace(/[^0-9]/g, ''));
        const finalValue = isNaN(parsedValue) ? '0' : Math.min(parsedValue, 100).toString();
        formik.setFieldValue(name, finalValue);
    };


    const onClickHandler = () => {
        dispatch(setAddCutAC(false));
    };

    const handleSubmit = async (values: MyFormValues) => {
        try {
            const data = {
                date_creation: selectedDate,
                reading: parseInt(values.reading),
                speaking: parseInt(values.speaking),
                listening: parseInt(values.listening),
                writing: parseInt(values.writing),
                grammar: parseInt(values.grammar),
            };


            await dispatch(postStudentInfoCut({ data,groupId, studentId }));

            dispatch(setAddCutAC(false));
            dispatch(fetchStudentCuts({groupId,studentId}));
            success();
        } catch (error) {
            console.error('Произошла ошибка при отправке данных:', error);
        }
    };


    const formik = useFormik<MyFormValues>({
        initialValues: {
            date: '',
            reading: '',
            speaking: '',
            listening: '',
            writing: '',
            grammar: '',
        },
        onSubmit: handleSubmit,
        enableReinitialize: true,
    });

    return (
        <>
            <p className="h3 popup-title">Добавить срез</p>
            <form action="#" className="form" onSubmit={formik.handleSubmit}>
                <div className="fields-row" onClick={togglePopup}>
                    <div className="field has-icon-inp">
                        <label className={`field-name ${selectedDate ? 'active-label' : ''}`}>Дата среза</label>
                        <div className="inp-box">
                            <input
                                style={{ cursor: 'pointer', caretColor: 'transparent' }}
                                type="text"
                                className="form-control has-icon datepicker"
                                name="date"
                                value={selectedDate}
                                onChange={formik.handleChange}
                                onFocus={() => handleFocus(0)}
                                onBlur={handleBlur}
                                autoComplete="off"
                                spellCheck="false"
                            />
                            <span className="icon">
                                <CalendarIcon/>
                             </span>
                        </div>
                    </div>
                </div>
                <div className="fields-row two-cols">
                    <div className={`field ${isFilled[1] ? 'filled' : ''}`}>
                        <label className={`field-name ${formik.values.reading ? 'active-label' : ''}`}>
                            Чтение
                        </label>
                        <div className="inp-box">
                            <input
                                type="number"
                                name="reading"
                                className="input-color form-control number percents-inp"
                                value={formik.values.reading}
                                onFocus={() => handleFocus(1)}
                                onChange={handleChange}
                                maxLength={1}
                            />
                            <span className="percents-inp-value">
                                 <span>{formik.values.reading}</span> %
                                </span>
                        </div>
                    </div>

                    <div className={`field ${isFilled[2] ? 'filled' : ''}`}>
                        <label className={`field-name ${formik.values.speaking ? 'active-label' : ''}`}>
                            Говорение
                        </label>
                        <div className="inp-box">
                            <input
                                type="number"
                                name="speaking"
                                className="form-control number percents-inp"
                                value={formik.values.speaking}
                                onChange={handleChange}
                                onFocus={() => handleFocus(2)}
                                maxLength={1}
                            />
                            <span className="percents-inp-value">
                                 <span>{formik.values.speaking}</span> %
                            </span>
                        </div>
                    </div>
                </div>
                <div className="fields-row two-cols">
                    <div className={`field ${isFilled[3] ? 'filled' : ''}`}>
                        <label className={`field-name ${formik.values.listening ? 'active-label' : ''}`}>
                            Аудирование
                        </label>
                        <div className="inp-box">
                            <input
                                type="number"
                                name="listening"
                                value={formik.values.listening}
                                onChange={handleChange}
                                className="form-control number percents-inp"
                                onFocus={() => handleFocus(3)}
                                maxLength={1}
                            />
                            <span className="percents-inp-value">
                             <span>{formik.values.listening}</span> %
                            </span>
                        </div>
                    </div>
                    <div className={`field ${isFilled[4] ? 'filled' : ''}`}>
                        <label className={`field-name ${formik.values.writing ? 'active-label' : ''}`}>
                            Письмо
                        </label>
                        <div className="inp-box">
                            <input
                                type="number"
                                name="writing"
                                value={formik.values.writing}
                                onChange={handleChange}
                                className="form-control number percents-inp"
                                onFocus={() => handleFocus(4)}
                                maxLength={1}
                            />
                            <span className="percents-inp-value">
                                <span>{formik.values.writing}</span> %
                            </span>
                        </div>
                    </div>
                </div>
                <div className="fields-row two-cols">
                    <div className={`field ${isFilled[5] ? 'filled' : ''}`}>
                        <label className={`field-name ${formik.values.grammar ? 'active-label' : ''}`}>
                            Грамматика
                        </label>
                        <div className="inp-box">
                            <input
                                type="number"
                                name="grammar"
                                value={formik.values.grammar}
                                onChange={handleChange}
                                className="form-control number percents-inp"
                                onFocus={() => handleFocus(5)}
                                maxLength={1}
                            />
                            <span className="percents-inp-value">
                              <span>{formik.values.grammar}</span> %
                            </span>
                        </div>
                    </div>
                </div>
                <button type="submit" className="btn full-width">
                    <span>Добавить</span>
                </button>
            </form>
            <span className="js-close-popup" onClick={onClickHandler}>
        <CloseIcon/>
      </span>
            {isOpen &&  <CutCalendar onClose={handleClose} onDateSelected={handleDateSelected} />}
        </>
    );
};
